module.exports = __webpack_public_path__ + "img/406.1ecdde0b.png";